
export abstract class AnalyticsService {

    abstract eventTrack(tagName: string, extras: any);
}
